import DelegationAddFromAllMileagesRequest, {
  DelegationAddFromAllMileagesRequestVehicleType,
} from "../../../api/raily/delegation/add-from-all-mileages/delegation-add-from-all-mileages.request";
import DelegationAddFromAllMileagesParams, {
  DelegationAddFromAllMileagesParamsVehicleType,
} from "./delegation-add-from-all-mileages-params";

const createVehicleType = (
  type: DelegationAddFromAllMileagesParamsVehicleType | undefined,
): DelegationAddFromAllMileagesRequestVehicleType | undefined => {
  switch (type) {
    case DelegationAddFromAllMileagesParamsVehicleType.CAR_GT_900CM3:
      return DelegationAddFromAllMileagesRequestVehicleType.CAR_GT_900CM3;
    case DelegationAddFromAllMileagesParamsVehicleType.CAR_LE_900CM3:
      return DelegationAddFromAllMileagesRequestVehicleType.CAR_LE_900CM3;
    case DelegationAddFromAllMileagesParamsVehicleType.COMPANY_OWNED:
      return DelegationAddFromAllMileagesRequestVehicleType.COMPANY_OWNED;
    case DelegationAddFromAllMileagesParamsVehicleType.MOPED:
      return DelegationAddFromAllMileagesRequestVehicleType.MOPED;
    case DelegationAddFromAllMileagesParamsVehicleType.MOTORCYCLE:
      return DelegationAddFromAllMileagesRequestVehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const create = (
  params: DelegationAddFromAllMileagesParams,
): DelegationAddFromAllMileagesRequest => {
  return {
    address: params.address,
    cardNumber: params.cardNumber,
    companyId: params.companyId,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    distanceMax: params.distanceMax,
    distanceMin: params.distanceMin,
    endAddress: params.endAddress,
    cargoCompanyName: params.cargoCompanyName,
    humanId: params.humanId,
    midAddress: params.midAddress,
    mileageNumber: params.mileageNumber,
    startAddress: params.startAddress,
    workerName: params.workerName,
    vehicleType: createVehicleType(params.vehicleType),
  };
};

const delegationAddFromAllMileagesRequestFactory = {
  create,
};

export default delegationAddFromAllMileagesRequestFactory;
